export interface ProductsNeeded {
  [key: string]: string;
}

export interface ConfigurationFeatures {
  ssoIntegrations: string[];
  sharedComponents: string[];
  productsNeeded: ProductsNeeded[];
}

export enum Products {
  CITUS = 'multicare.mobile.enabled',
  EFORMS = 'multicare.eforms.enabled',
  SNF   = 'snf.app.url.root',
  SL    = 'sl.app.url.root',
  LPC   = 'lpc.app.url.root',
  PD    = 'pd.app.url.root',
  PP    = 'paymentportal.enabled',
  TS    = 'ssointegrations.truesense.enabled',
  SC    = 'ssointegrations.surecount.enabled',
  S4B   = 'sb.module.enabled',
  RTO   = 'rt.online.enabled'
}
